import React from 'react';
import { Field } from 'redux-form';
import { SelectField } from 'Common/SemanticWrapper';
import { days } from 'Common/Constants';

export default props => {
  const { name, ...rest } = props;

  return (
    <Field
      name={name}
      component={SelectField}
      label={'Day of Week'}
      options={days}
      search={dayFilter}
      {...rest}
    />
  );
};

const dayFilter = (options, query) => {
  const re = new RegExp('^' + query, 'i');
  return options.filter(opt => re.test(opt.text));
};



// WEBPACK FOOTER //
// ./src/common/Components/DayDropDown/DayDropDown.js